import { Host, h } from "@stencil/core";
/* OTHER LIBRARIES IMPORTS */
/* CUSTOM IMPORTS */
export class GxgMenuSlimList {
    constructor() {
        this.listTitle = undefined;
    }
    // 2. REFERENCE TO ELEMENTS //
    // 3.STATE() VARIABLES //
    // 4.PUBLIC PROPERTY API | WATCH'S //
    // 5.EVENTS (EMIT) //
    // 6.METHODS //
    // 7.LISTENERS //
    // 8.PUBLIC METHODS API //
    // 9.LOCAL METHODS //
    // 10.RENDER() FUNCTION //
    render() {
        return (h(Host, null, h("div", { class: "wrapper", part: "wrapper" }, this.listTitle ? (h("span", { class: "title-wrapper", part: "title-wrapper" }, h("gxg-title", { type: "title-05", part: "title" }, this.listTitle))) : null, h("ul", { part: "list" }, h("slot", null)))));
    }
    static get is() { return "gxg-menu-slim-list"; }
    static get encapsulation() { return "shadow"; }
    static get originalStyleUrls() {
        return {
            "$": ["list.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["list.css"]
        };
    }
    static get properties() {
        return {
            "listTitle": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The menu-list title"
                },
                "attribute": "list-title",
                "reflect": false
            }
        };
    }
}
//# sourceMappingURL=list.js.map
